import axios from 'axios';
import { BASE_URL } from 'utils/constants/Api';

export type TSendChatFeedback = {
  chatId: string;
  feedback: 'ACCEPTED' | 'REJECTED';
  discussionId: string;
  searchUrl: string;
};

function useChatFeedback() {
  const sendChatFeedback = async (
    payload: TSendChatFeedback,
  ): Promise<void> => {
    try {
      await axios.post(`${BASE_URL}/movement-chatbot/feedback`, payload, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch (_e) {}
  };

  return {
    sendChatFeedback,
  };
}

export default useChatFeedback;
